import { PassportUserManagementServiceClientConfigFactory } from '@amzn/coral-config_passport-user-management-service';
import {
  PassportUserManagementService,
  passportUserManagementServiceHttpBindingInterceptor,
} from '@amzn/coral_com-amazon-passportusermanagementservice';
import {
  CoralClientFactory,
  CoralFetchHandler,
  InterceptingHandler,
} from '@amzn/ihm-js-coral-client';
import envHelper from '../config/env';
import AcceptInvitation from '../models/AcceptInvitationRequest';
import CreateInvitationRequest from '../models/CreateInvitationRequest';
import GetDeactivatedUsersResponse from '../models/GetDeactivatedUsersResponse';
import GetInvitedUsersForLogisticsPartyResponse from '../models/GetInvitedUsersForLogisticsPartyResponse';
import GetRequestedUserProfileInfoResponse from '../models/GetRequestedUserProfileInfoResponse';
import GetUserProfileInfoResponse from '../models/GetUserProfileInfoResponse';
import GetUsersForLogisticsPartyResponse from '../models/GetUsersForLogisticsPartyResponse';
import UpdateUserProfileInfoRequest from '../models/UpdateUserProfileInfoRequest';
import UpdateUserProfileInfoResponse from '../models/UpdateUserProfileInfoResponse';
import isSiteExternal from '../utils/isSiteExternal';
import PassportRequestOptionsInterceptor from './PassportRequestOptionsInterceptor';
import RequestOptionsInterceptor from './RequestOptionsInterceptor';

const clientFactory = new CoralClientFactory(
  [PassportUserManagementServiceClientConfigFactory],
  envHelper.getEnv(),
  new InterceptingHandler(new CoralFetchHandler(), [
    passportUserManagementServiceHttpBindingInterceptor,
    isSiteExternal()
      ? new RequestOptionsInterceptor()
      : new PassportRequestOptionsInterceptor(),
  ])
);

/**
 * Custom web server to override serialization/deserialization
 */
class CustomWebServer extends PassportUserManagementService {
  constructor(config, handler) {
    super(config, handler);
    this.handler.handlerChain.interceptor.operations.GetUserProfileInfo.deserializationFn =
      GetUserProfileInfoResponse.fromJson;
    this.handler.handlerChain.interceptor.operations.UpdateUserProfileInfo.serializationFn =
      UpdateUserProfileInfoRequest.toJson;
    // to handle inheritacne in coral models
    this.handler.handlerChain.interceptor.operations.UpdateUserProfileInfo.deserializationFn =
      UpdateUserProfileInfoResponse.fromJson;
    this.handler.handlerChain.interceptor.operations.AcceptInvitation.serializationFn =
      AcceptInvitation.toJson;
    this.handler.handlerChain.interceptor.operations.GetUsersForLogisticsParty.deserializationFn =
      GetUsersForLogisticsPartyResponse.fromJson;
    this.handler.handlerChain.interceptor.operations.GetInvitedUsersForLogisticsParty.deserializationFn =
      GetInvitedUsersForLogisticsPartyResponse.fromJson;
    this.handler.handlerChain.interceptor.operations.CreateInvitation.serializationFn =
      CreateInvitationRequest.toJson;
    this.handler.handlerChain.interceptor.operations.GetDeactivatedUsers.deserializationFn =
      GetDeactivatedUsersResponse.fromJson;
      this.handler.handlerChain.interceptor.operations.GetRequestedUserProfileInfo.deserializationFn =
      GetRequestedUserProfileInfoResponse.fromJson;
  }
}

const passportUserManagementServiceClient = clientFactory.get(CustomWebServer);

export default passportUserManagementServiceClient;
